<template>
  <div class="search">
    <div class="tr">
      <div class="search-icon">
        <span class="fal fa-search fa-lg"></span>
      </div>
      <div class="td">
        <span class="search-input">
          <input type="text" name="search" @click.self="clicked()" @input="input" v-model="search" @keyup="determineClearButton()" :placeholder="placeholder" autocomplete="off"/>
          <div v-if="showClearButton" v-on:click="clearSearch()" class="clear-button">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String
    },
    searchValue: {
      type: String
    }
  },
  watch: {
    searchValue: {
      immediate: true,
      handler (val) {
        this.search = val;
      }
    }
  },
  data: function() {
    return {
      search: "",
      showClearButton: false
    }
  },
  methods: {
    input(event) {
      this.$emit('searcher', event.target.value);
    },
    clearSearch: function() {
      this.search = '';
      this.clear = this.search ? true : false;
      this.$emit('searcher', '');
      this.determineClearButton();
    },
    determineClearButton: function() {
      this.showClearButton = this.search ? true : false;
    },
    clicked(event) {
      this.$emit('clicked');
    }
  }
}
</script>